module.exports = __webpack_public_path__ + "img/network.feac9347.png";